import { Component, inject, Injector, OnInit } from '@angular/core';
import { CompaniesDialogBaseComponent } from '../companies-dialog-base/companies-dialog-base.component';
import { CompaniesService, ICompanyUpdateModel } from "../../../../services/companies.service";
import { catchError, switchMap } from 'rxjs';

@Component({
    selector: 'app-edit-company',
    templateUrl: '../companies-dialog-base/companies-dialog-base.component.html',
    styleUrls: ['../companies-dialog-base/companies-dialog-base.component.css'],
    standalone: false
})
export class EditCompanyComponent extends CompaniesDialogBaseComponent<ICompanyUpdateModel> implements OnInit {
    private companyService: CompaniesService = inject(CompaniesService);

    constructor(protected injector: Injector) {
        super(injector);
        this.dialogId = "editCompany";

    }

    async ngOnInit() {
      super.ngOnInit();

      this.companyService.getCompany(this.model.Id)
        .subscribe(company => {
          this.model = company;

          if (this.model.ParentCompanyId == undefined)
            this.showParentCompanyField = false;
        });

    }
    public submit() {
        this.externalAPI.companyId=this.model.Id;
        this.companyService.update(this.model).pipe(
            switchMap(() => this.companyService.saveSettings(this.externalAPI)),
        ).subscribe({
            next: () => {
                this.onCreated.emit();
                this.close();
                this.syncService.NotifyEntityChanged("Company", 0);
                super.submit();
            }
        });
    }

}

